import { Button, Input, Typography } from '@breetometer/components';
import { BvnValidationIcon } from 'BreetAssets';
import { handleApiError, preventFormDefault, showToast } from 'BreetHelpers';
import { useFormData, useModalApi } from 'BreetHooks';
import { useUpdateKybMutation } from 'BreetRedux';
import { useCallback } from 'react';

import { BvnValidationSchema } from './DialogBvnValidation.helpers';

const DialogBvnValidation = () => {
	const [updateKyb, { isLoading }] = useUpdateKybMutation();

	const { closeModalDirect } = useModalApi();

	const bvnValidationFormData = useFormData(BvnValidationSchema, { directorBvn: '', directorDob: '' }, { mode: 'onChange' });

	const validateBvn = useCallback(() => {
		updateKyb({
			directorBvn: bvnValidationFormData.hookFormProps.watch('directorBvn'),
			directorDob: bvnValidationFormData.hookFormProps.watch('directorDob'),
		})
			.unwrap()
			.then(() => {
				showToast('success', 'BVN validated');
				bvnValidationFormData.hookFormProps.reset({
					directorBvn: '',
					directorDob: '',
				});
				closeModalDirect('bvnValidation');
			})
			.catch(handleApiError);
	}, [bvnValidationFormData.hookFormProps, closeModalDirect, updateKyb]);

	return (
		<div className='bvn-validation bg-primary-500'>
			<div className='bvn-validation-header'>
				<BvnValidationIcon className='bvn-header-icon' />
				<Typography
					as='h4'
					className='color-neutral-50'
				>
					BVN Validation Required
				</Typography>
				<Typography className='color-primary-100'>Validate your BVN to securely generate your virtual bank account.</Typography>
			</div>

			<form
				className='new-drop-down-input'
				onSubmit={preventFormDefault}
			>
				<Input
					label="Director's BVN"
					id='director-bvn'
					widthType='full'
					{...bvnValidationFormData.hookFormProps.register('directorBvn')}
					errorMessage={bvnValidationFormData.hookFormProps.formState.errors.directorBvn?.message}
					required
				/>

				<Input
					label='Date of Birth'
					id='date-of-birth'
					widthType='full'
					{...bvnValidationFormData.hookFormProps.register('directorDob')}
					type='date'
					errorMessage={bvnValidationFormData.hookFormProps.formState.errors.directorDob?.message}
					required
				/>

				<div className='bt_button-container'>
					<Button
						onClick={validateBvn}
						isLoading={isLoading}
						disabled={!bvnValidationFormData.isFormCompleted || !bvnValidationFormData.hookFormProps.formState.isDirty}
						type='button'
					>
						Validate
					</Button>
				</div>
			</form>
		</div>
	);
};

export default DialogBvnValidation;
